'use strict';

const angular = require('angular');

import { ISeason, IPickupOption, ISeasonUtilsService, IPickupOptionsService } from '../../interfaces';

class PayCalendarDeadline {
  deadline: Date;
  isOpened: boolean;

  constructor(deadline) {
    this.deadline = deadline;
    this.isOpened = false;
  }
}

export class AdminSeasonEditComponent {
  season: ISeason;
  firstEventDate: Date;
  errors = {};
  isNew: Boolean = false;
  submitted: Boolean = false;
  $http: ng.IHttpService;
  getDateForInterval: Function;

  SeasonUtils: ISeasonUtilsService;
  pickupOptions: IPickupOption[];

  payCalendarDeadlines: PayCalendarDeadline[] = [];

  // Options for angular-ui datepicker
  options = {
    customClass: this.getDayClass,
    showWeeks: true
  }; 

  /**
   * Datepicker has to pass date with hours, minutes and seconds to zero
   */
  getDayClass(data) {
    var date = data.date,
      mode = data.mode;
    if (mode === 'day') {
      var dayToCheck = new Date(date).setHours(0,0,0,0);
    }

    return '';
  }

  /*ngInjector*/
  constructor($http, SeasonUtils: ISeasonUtilsService, PickupOptionsService: IPickupOptionsService) {
    this.$http = $http;
    //this.getDateForInterval = SeasonUtils.getDateForInterval;
    this.SeasonUtils = SeasonUtils;

    let scope = this;
    PickupOptionsService.get().then((pickupOptions) => {
      scope.pickupOptions = _.difference(pickupOptions, scope.season.activePickupOptions);
    });
  }

  $onInit() {
    let resolve = (this as any).resolve;
    if (_.has(resolve, 'season') && resolve.season !== null) {
      this.season = _.cloneDeep(resolve.season);
      this.firstEventDate = new Date(this.season.firstEventDate);
      this.isNew = false;

      let paymentsDeadlinesToDates: Date[] = [];
      for (let p of this.season.paymentDeadlines) {
        paymentsDeadlinesToDates.push(new Date(p));
      }
      this.payCalendarDeadlines = this.parseToPayCalendarDeadlines(paymentsDeadlinesToDates);

    } else {
      this.season = {
        firstEventDate: new Date(),
        eventIntervalInDays: 7,
        numberOfEvents: 36,
        activePickupOptions: [],
        basketPrice: 0,
        paymentDeadlines: []
      } as any;
      this.updatePaymentDeadlines();
      this.isNew = true;
    }
  }

  updatePaymentDeadlines() {
    if ( this.season.numberOfEvents!=null && this.season.numberOfEvents>0) {
      this.payCalendarDeadlines = this.parseToPayCalendarDeadlines( this.SeasonUtils.getDeadlinesForPayments(this.season) );
    } else {
      this.payCalendarDeadlines = [];
    }

  }

  //Parsing payment deadlines to a format for calendar option
  parseToPayCalendarDeadlines(paymentDeadlines: Date[]) {
    let payCalendarDeadlines: PayCalendarDeadline[] = [];
    for(let pay of paymentDeadlines) {
      payCalendarDeadlines.push(new PayCalendarDeadline(pay));
    }
    return payCalendarDeadlines;
  }

  //Parsing payCalendar deadlines to a format for save on server
  parseToPaymentDeadlines(payCalendarDeadlines: PayCalendarDeadline[]) {
    let paymentDeadlines: string[] = [];
    for(let pay of payCalendarDeadlines) {
      paymentDeadlines.push(pay.deadline.toString());
    }
    return paymentDeadlines;
  }

  openCalendar(payCalendarDeadline: PayCalendarDeadline) {
    payCalendarDeadline.isOpened = true;
  }

  addActivePickupOption(pickupOption) {
    this.season.activePickupOptions.push(pickupOption.toJSON());
  }

  getInactivePickupOptions() {
    return _.difference(this.pickupOptions, this.season.activePickupOptions);
  }

  removeActivePickupOption(pickupOption) {
    this.season.activePickupOptions = _.without(this.season.activePickupOptions, pickupOption);
  }

  save(form) {
    this.submitted = true;
    if (form.$valid) {
      //parsing to paymentDeadline format for save on server
      this.season.paymentDeadlines = this.parseToPaymentDeadlines(this.payCalendarDeadlines);
      
      //Clean the time for the first event date because time will added on pickup option
      this.season.firstEventDate = this.firstEventDate.toDateString();

      //Building path and method
      let method = this.$http.patch;
      let path = '';
      if (this.isNew) {
        method = this.$http.post;
      } else {
        path += this.season._id;
      }
      
      method('/api/seasons/' + path, this.season)
        .then((result) => {
          this.season = result.data as ISeason;
          this.ok();
        })
        .catch(err => {
          err = err.data;
          this.errors = {};
          // Update validity of form fields that match the mongoose errors
          angular.forEach(err.errors, (error, field) => {
            form[field].$setValidity('mongoose', false);
            this.errors[field] = error.message;
          });

        });
    }
  }

  ok() {
    (this as any).resolve.season = this.season;
    (this as any).close({ $value: this.season });
  };

  cancel() {
    (this as any).dismiss({ $value: 'cancel' });
  };
}


export default angular.module('terrappApp.adminSeasons')
  .component('adminSeasonEdit', {
    template: require('./adminSeasonEdit.html'),
    controller: AdminSeasonEditComponent,
    controllerAs: '$ctrl',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
  }).name;



// WEBPACK FOOTER //
// ./client/app/admin/adminSeasons/adminSeasonEdit.component.ts